import { atom } from 'jotai';

export const networkDimensionListAtom = atom([
  'network_request_url_host',
  'network_request_url_path',
  'network_request_http_method',
  'network_request_response_code',
  // 'network_request_url_scheme',
  'network_request_url_query',
]);
export interface Rule {
  display: string;
  field: string;
  key: string | null;
  op: string;
  originalField: string;
  value: string;
}
export interface DrilldownItem {
  name: string;
  rule: Rule[][];
}
export const drillDownListAtom = atom<DrilldownItem[]>([]);

export const list4BreadcrumbAtom = atom((get) => {
  return [
    // {
    //   name: 'All Traffic',
    //   rule: [],
    // },
    ...get(drillDownListAtom),
  ];
});

export const drillDownFiltersAtom = atom((get) => {
  const drilldownList = get(drillDownListAtom);
  return drilldownList.reduce<Rule[][]>((sum, it) => {
    const { rule = [] } = it;
    return [...sum, ...rule];
  }, []);
});

export const traceIdInfoAtom = atom({
  open: false,
  info: {},
});
